module.exports = __webpack_public_path__ + "static/etapas-b9858eab37cbe572da16a28cada2103b.png";